import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from '../../shared/Modal';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { FilterBarUtil } from '../../../utils/filter_bar_util';
import ExpandableFilterPanel from '../ExpandableFilterPanel';
import FilterBar from '../FilterBar';

class GlobalFiltersModal extends React.Component {
  getMappedFilters = () => {
    const pageStrings = StringConstantsMixin.strings.FILTERS;
    return {
      mappedFilters: [
        {
          display: pageStrings.SORT_LABEL,
          key: 'sort',
          enabledKey: 'sort',
          type: 'sort',
          nested: true,
          config: this.props.filters.sort
        },
        {
          display: pageStrings.DIFFICULTY,
          key: 'difficulty',
          enabledKey: 'difficulty',
          type: 'cloud',
          nested: false,
          config: this.props.filters.difficulty
        },
        {
          display: pageStrings.LENGTH,
          key: 'lengths',
          enabledKey: 'length',
          type: 'slider',
          nested: false,
          config: this.props.filters.lengths
        },
        {
          display: pageStrings.ELEV_GAIN,
          key: 'elevation_gain',
          enabledKey: 'elevation_gain',
          type: 'slider',
          nested: false,
          config: this.props.filters.elevation_gain
        },
        {
          display: pageStrings.RATING,
          key: 'minRating',
          enabledKey: 'rating',
          type: 'rating',
          nested: false,
          config: this.props.filters.minRating
        },
        {
          display: pageStrings.ACTIVITY_LABEL,
          key: 'activities',
          enabledKey: 'activity',
          type: 'cloud',
          nested: true,
          truncate: true,
          config: this.props.filters.activities
        },
        {
          display: pageStrings.FEATURES_LABEL,
          key: 'features',
          enabledKey: 'feature',
          type: 'cloud',
          nested: true,
          truncate: true,
          config: this.props.filters.features
        },
        {
          display: pageStrings.SUITABILITY,
          key: 'access',
          enabledKey: 'access',
          type: 'cloud',
          nested: true,
          config: this.props.filters.access
        },
        {
          display: pageStrings.ROUTE_TYPE,
          key: 'route_type',
          enabledKey: 'route_type',
          type: 'cloud',
          nested: false,
          config: this.props.filters.route_type
        },
        {
          display: pageStrings.TRAIL_TRAFFIC,
          key: 'visitor_usage',
          enabledKey: 'visitor_usage',
          type: 'cloud',
          nested: true,
          config: this.props.filters.visitor_usage
        },
        {
          display: pageStrings.TRAIL_COMPLETION,
          key: 'completed',
          enabledKey: 'completed',
          type: 'cloud',
          nested: true,
          config: this.props.filters.completed
        },
        {
          display: 'Linked',
          key: 'linked',
          enabledKey: 'linked',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.linked
        },
        {
          display: 'Parks',
          key: 'areas',
          enabledKey: 'area',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.areas
        },
        {
          display: 'City',
          key: 'cities',
          enabledKey: 'city',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.cities
        },
        {
          display: 'State',
          key: 'states',
          enabledKey: 'state',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.states
        },
        {
          display: 'Country',
          key: 'countries',
          enabledKey: 'country',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.countries
        }
      ]
    };
  };

  render() {
    const { handleClose, clearAllFilters, resultsCount } = this.props;
    const buttonText =
      resultsCount === null ? StringConstantsMixin.strings.FILTER : StringConstantsMixin.strings.SEE_RESULTS.replace('{resultsCount}', resultsCount);

    const items = [];
    this.getMappedFilters().mappedFilters.map((filter, index) => {
      if (this.props.enabledFilters.indexOf(filter.enabledKey) === -1) {
        return;
      }
      const filterContent = FilterBarUtil.getFilterContent(this.props, filter, filter.key);
      items.push(
        <ExpandableFilterPanel
          key={filter.key}
          title={filter.display}
          content={filterContent.component}
          truncate={filter.truncate}
          variant={filter.variant}
          dividerBars
        />
      );
    });

    return (
      <Modal handleBackgroundClick={handleClose}>
        <div className={styles.container}>
          <button className="close" onClick={handleClose} />
          <button className={styles.actionHeader} onClick={clearAllFilters}>
            {StringConstantsMixin.strings.RESET}
          </button>
          <div className={styles.title}>Filters</div>
          <div className={styles.scrollable}>{items}</div>
          <div className={styles.ctaFooter}>
            <Button className={styles.button} onClick={handleClose}>
              {buttonText}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default GlobalFiltersModal;
